<div class="flex flex-col justify-center items-center">


    <h2>Tema applicazione</h2>

    <div class="flex justify-center items-center w-full py-2 border-b-2 border-primary-200 pb-4">
        <div class="flex flex-wrap items-center justify-center gap-4">
            <div class="card-primary bg-slate-950/90 text-white flex flex-col justify-center items-center break-before-right cursor-pointer w-40 h-40 {{themeSelected == 'dark' ? 'border-4 border-primary-500' : ''}}"
                (click)="switchTheme(true)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z" />
                    <path d="M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2" />
                    <path d="M19 11h2m-1 -1v2" />
                </svg>
                <p>Tema scuro</p>
            </div>

            <div class=" card-primary bg-white text-black flex flex-col justify-center items-center break-before-right cursor-pointer w-40 h-40 {{themeSelected == 'light' ? 'border-4 border-primary-500' : ''}}"
                (click)="switchTheme(false)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                    <path d="M12 5l0 -2" />
                    <path d="M17 7l1.4 -1.4" />
                    <path d="M19 12l2 0" />
                    <path d="M17 17l1.4 1.4" />
                    <path d="M12 19l0 2" />
                    <path d="M7 17l-1.4 1.4" />
                    <path d="M6 12l-2 0" />
                    <path d="M7 7l-1.4 -1.4" />
                </svg>
                <p>Tema chiaro</p>
            </div>

            <div class="card-primary bg-background-dark flex flex-col justify-center items-center break-before-right cursor-pointer w-40 h-40 {{themeSelected == 'auto' ? 'border-4 border-primary-500' : ''}}"
                (click)="switchTheme()">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-12 h-12">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10z" />
                    <path d="M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9" />
                    <path d="M16 9h2" />
                </svg>
                <p>Auto</p>
            </div>

        </div>
    </div>
</div>
<!--<div class="flex flex-col w-full">

    <h2 class="my-2">Logo Custom</h2>
    <p>Carica un'immagine se vuoi usare il tuo logo al posto di quello di Seraplastic (Formati accettati: png, possibilmente con sfondo trasparente)</p>
    <div class="flex justify-start items-center gap-2">

        <label class="rounded-lg flex justify-center items-center text-green-600 bg-green-200 hover:bg-green-600 p-2 transition-all duration-300 hover:text-white shadow-lg cursor-pointer" tabindex="0">
            <input #fileUpload id="fileUpload" (change)="loadLogoToBase64($event)" type="file"
                accept=".png" class="dl-button cursor-pointer hidden">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                    d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m6.75 12l-3-3m0 0l-3 3m3-3v6m-1.5-15H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
            </svg>
    
            Carica un'immagine
        </label>

        <div class="w-auto">
            <button ejs-button class="form-secondary-action-button" (click)="saveImage()" *ngIf="logoBase64 != undefined" [disabled]="logoBase64 == undefined">
                Salva immagine
            </button>
        </div>
    </div>

    <div class="card-primary bg-white mx-0 my-5 w-80">
        <img src="{{logoBase64 || imgPath}}" width="300px">
    </div>

    

</div>-->